import React, { useState } from "react";
import { IRefDocTableComponent, IReferenceDoc, SWTypes } from "interfaces/sw/SWInterfaces";
import "./RefDocs.scoped.scss";
import downloadIcon from "media/icons/dls/download.svg";
import SWApi from "apis/sw/SWApi";
import { showErrorToast } from "store/toast/toastActions";
import { getResponseErrorMessage } from "utilities/validationErrorHelpers";
import ModalSpinner from "components/common/ModalSpinner";
import { useDispatch } from "react-redux";
import RefDocTableCell from "components/sw/manage/refDocs/RefDocTableCell";
import { ImageDataDestinations } from "store/manageSW/manageSWTypes";
import RefDocTableEditor from "../../../../sw/manage/refDocs/RefDocTableEditor";

interface IRefDocsProps {
  refDocs: IReferenceDoc[],
  swGuid: string,
  version: number,
  swType: SWTypes
}

const RefDocs: React.FC<IRefDocsProps> = ({ refDocs, swGuid, version, swType }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const downloadRefDoc = async (filename: string) => {
    try {
      setIsLoading(true);
      const blobUri = await SWApi.getSWBlobURL(swGuid, version, filename);
      const link = document.createElement("a");
      link.href = blobUri;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up the object URL
      URL.revokeObjectURL(blobUri);
    } catch (err: any) {
      dispatch(showErrorToast(`Failed to download file: ${getResponseErrorMessage(err)}`));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {refDocs
        .map(refDoc => {
          if (refDoc.type === 'File')
            return (
              <div
                className="row"
                key={refDoc.guid}
              >
                <label>{refDoc.label}</label>
                <span className="value">
                  {refDoc.refDocData}
                </span>
                <span className="downloadSpan">
                  <button
                    className="secondary-button download-button"
                    onClick={() => downloadRefDoc(refDoc.refDocData)}
                    title="Download"
                  >
                    <img
                      src={downloadIcon}
                      className="icon-small"
                      alt="Download"
                    />
                  </button>
                </span>
              </div>
            )
          else if (refDoc.type === 'Link')
            return (
              <div
                className="row"
                key={refDoc.guid}
              >
                <span>
                  <a
                    href={refDoc.refDocData}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {refDoc.label}
                  </a>
                </span>
              </div>
            )
          else if (refDoc.tableData)
            return (
              <div
                className="tableRow"
                key={refDoc.guid}
              >
                    <RefDocTableEditor
                        allowEdit={false}
                        refDocGuid={refDoc.guid}
                        label={refDoc.label}
                        tableComponent={refDoc.tableData}
                        swGuid={swGuid}
                        swVersion={version}
                        swType={swType}
                        imageDataDestination={ImageDataDestinations.Approval}
                        enableTimeUpload={false}
                    />
              </div>
            )
          else
            return undefined;
        })
      }
      {isLoading &&
        <ModalSpinner />
      }
    </>
  )
}

export default RefDocs;